// https://stackoverflow.com/questions/9719570/generate-random-password-string-with-requirements-in-javascript
export default class Random {
    randomByte() {
        const crypto = window.crypto || window['msCrypto'] || null;
        // http://caniuse.com/#feat=getrandomvalues
        if (crypto && crypto.getRandomValues) {
            let result = new Uint8Array(1);
            crypto.getRandomValues(result);
            return result[0];
        }
        return Math.floor(Math.random() * 256);
    }
    generate(chars, length, overwriteChars) {
        let password = "";
        for (let i = 0; i < length; i++) {
            password += overwriteChars[i] || this.randomArrayItem(chars);
        }
        return password;
    }
    randomNumber(max) {
        return this.randomByte() % max;
    }
    randomArrayItem(chars) {
        return chars[this.randomNumber(chars.length)];
    }
}
